import React from 'react';
import { Navigate } from 'react-router-dom';

function SuperAdminRouteGuard({ user, children }) {
  const isSuperAdmin = user?.role === 'Super Admin';
  const isSuperAdminView = !user?.viewMode || user.viewMode === 'super_admin';

  if (!isSuperAdmin || !isSuperAdminView) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

export default SuperAdminRouteGuard;
